import { Location } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useLocationById(locationId: string) {
  const url = `/v2/orm/locations/${locationId}`;
  const request = new Request(url);

  return useAuthenticatedRequest<Location>(request, {
    queryKey: ['locationId', locationId],
    enabled: Boolean(locationId),
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useLocationById;
